import type { AssetURLs } from '../attachments';
import type { ConflictItem, Item } from '../items';

export type KitStatus =
	| 'available'
	| 'checkedout'
	| 'await_checkout'
	| 'in_transit'
	| 'maintenance'
	| 'repair'
	| 'inspection'
	| 'expired'
	| 'in_custody'
	| 'empty'
	| 'incomplete';

export type KitAvailabilityStatus =
	| 'available'
	| 'available_partially'
	| 'unavailable_status'
	| 'unavailable_flag'
	| 'unavailable_allow'
	| 'unavailable_other'
	| 'unavailable_bulk';

export interface Kit {
	_id: string;
	name: string;
	status: KitStatus;
	/**
	 * @deprecated use itemQuantities
	 * @see itemQuantities
	 */
	items: Item[];
	cover: string | null;
	cover_url?: AssetURLs;
	created: string;
	modified: string;
	description: string;
	itemSummary: string;
	codes: string[];
	barcodes: string[];
	rfidcodes: string[];
	canReserve: KitAvailabilityStatus;
	canOrder: KitAvailabilityStatus;
	canCustody: KitAvailabilityStatus;
	allowReserve: boolean;
	allowOrder: boolean;
	allowCustody: boolean;
	fields: Record<string, string>;
	itemQuantities: Record<string, number>;
	locked?: boolean;
}

export enum KitConflict {
	AVAILABLE = 'AVAILABLE',
	UNAVAILABLE = 'UNAVAILABLE',
	RESTRICTED = 'RESTRICTED',
	PARTIALLY_AVAILABLE = 'PARTIALLY_AVAILABLE',
	PARTIALLY_RESTRICTED = 'PARTIALLY_RESTRICTED',
	AT_WRONG_LOCATION = 'WRONG_LOCATION',
	CHECKED_OUT = 'CHECKED_OUT',
	ASSIGNED = 'IN_CUSTODY',
	CHECKING_OUT = 'CHECKING_OUT',
	FLAGGED = 'FLAGGED',
	RESERVED = 'RESERVED',
	CANNOT_CHECKOUT = 'CANNOT_CHECKOUT',
	CANNOT_RESERVE = 'CANNOT_RESERVE',
	RETIRED = 'RETIRED',
	INCOMPLETE = 'INCOMPLETE',
	PARTIALLY_INCOMPLETE = 'PARTIALLY_INCOMPLETE',
	BUFFER_TIME = 'BUFFER_TIME',
}

export type ConflictKit = Omit<ConflictItem, 'kind'> & {
	locked: boolean;
};
